import React, { Component } from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import domain from '../domain'
import axios from 'axios'
import { MDBInput } from "mdbreact";
import moment from 'moment'
import { FadeLoader } from "react-spinners";
/**
 *  Home Page Popup Modal
 */

import colors from "../colors";
import ReactHTMLParser from "react-html-parser";
class DownloadModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableDownload: false,
      purpose: null,
      organization: null,
      check: false,
      agency: null,
      stateinfo: null,
      disabled: false,
      enableothers: false
    }
  }
  save = () => {
    const url = `${domain.DBServer}/save-user-download-data`
    const data = {
      theme: 'SNOW',
      product: this.props.product,

      user: this.props.user,

      purpose: this.state.purpose,
      subproduct: null

    }
    axios.request({
      method: 'post',
      url: url,
      data: data,
    }).then((result) => {
      if (result) {
        console.log(result.data)
        if (result.data) {
          console.log(result.data)
          let requestid = result.data.requestid
          if (requestid !== null) {
            if (this.props.product === 'Daily Snow Cover Area' || this.props.product === 'Spatial snowmelt rate forecast (3-days)') {
              this.handleDownloadLink()
            }
            else {
              this.handleDownload_one()
            }

          }
        }
      }
    })
  }
  onSubmit = async (e) => {
    e.preventDefault();
    console.log(this.state)
    if (this.state.purpose !== null) {
      this.save()

    }




  }
  handleDownloadLink = () => {
    console.log(this.props.d1)
    this.setState({
      loading: true
    })
    const method = 'POST';
    const url = `${domain.Fileserver}/download_multiple`
    let product = null
    if (this.props.product === 'Daily Snow Cover Area') {
      product = 'snowcover'

      axios
        .request({
          url,
          method,
          data: {
            theme: 'SNOW',
            product: product,
            d1: this.props.d1,
            d2: this.props.d2,
            user: this.props.user
          },
          responseType: 'blob', //important
        }).then((result) => {
          if (result) {
            const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `NHP_NRSC_${product}.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.props.toggle()
            this.setState({
              loading: false
            })
          }

        });
    }
    else {
      product = 'forecast'

      axios
        .request({
          url,
          method,
          data: {
            theme: 'SNOW',
            product: product,
            d1: this.props.snowdate,

            user: this.props.user
          },
          responseType: 'blob', //important
        }).then((result) => {
          console.log(result)
          if (result) {
            const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `NHP_NRSC_${product}.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.props.toggle()
            this.setState({
              loading: false
            })
          }

        });
    }

  };
  handleDownload_one = () => {
    const method = 'POST';
    this.setState({
      loading: true
    })
    console.log(this.props.snowdate)
    let product
    if (this.props.product === 'Snow Cover Fraction') {
      product = 'scf'
    }
    else if (this.props.product === 'Estimated spatial snowmelt rate') {
      product = 'esr'
    }
    const url = `${domain.Fileserver}/download_single_file`
    axios
      .request({
        url,
        method,
        data: {
          theme: 'SNOW',
          product: product,
          d1: this.props.snowdate,

          user: this.props.user
        },
        responseType: 'blob', //important
      })
      .then((result) => {
        if (result) {
          if (result.data) {
            const downloadUrl = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', `NHP_NRSC_${product}_${this.props.snowdate}.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.props.toggle()
          }
        }
      });
  };
  handleCheck = (e) => {
    this.setState({
      check: e.target.value,
      disabled: true,

    })
  }
  changeCountry = (e) => {
    this.setState({
      country: e.target.value
    })
  }
  changeAgency = (e) => {
    this.setState({
      agency: e.target.value
    })
  }
  changeState = (e) => {
    this.setState({
      stateinfo: e.target.value
    })
  }
  changeOrg = (e) => {
    this.setState({
      organization: e.target.value
    })
  }
  changePurpose = (e) => {
    this.setState({
      purpose: e.target.value
    })
  }
  changePurpose_multiple = (e) => {
    if (e.target.value !== '1') {
      let value = Array.from(e.target.selectedOptions, option => option.value);
      this.setState({ purpose: value, enableothers: false });

    }
    else {
      this.setState({
        enableothers: true,
       // purpose: null
      })
    }
  }
  render() {
    console.log(this.props)
    return (
      <MDBContainer >
        {/* <MDBBtn color="primary" onClick={this.toggle(14)}>MDBModal</MDBBtn> */}
        <MDBModal
          isOpen={this.props.modal}
          toggle={this.props.toggle}
          centered
          backdrop={false}
          size="lg"
        //     style={{
        //   textAlign: "justify",
        //   width: window.innerWidth<1000?"250px":"600px",

        //   overflow: "scroll",
        // }}
        >
          <MDBModalHeader
            className="text-center"
            titleClass="w-100 font-weight-bold"
            toggle={this.toggle}
            style={{ background: "#3f51b5", color: "white" }}
            toggle={this.props.toggle}
          >
            {this.props.title}
          </MDBModalHeader>
          <MDBModalBody
            style={{
              textAlign: "justify",
              height: window.innerHeight > 1000 ? "500px" : "300px",

              overflow: "scroll",
            }}
          >
            <form onSubmit={this.onSubmit}>

              {/* <div class="form-group row">
                <label for="inputcountry" class="col-sm-2 col-form-label">Country</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="inputcountry" placeholder="Country" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.country} onChange={this.changeCountry} />
                </div>
              </div>

              <div class="form-group row">
                <label for="inputstate" class="col-sm-2 col-form-label">State</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="inputstate" placeholder="State" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.stateinfo} onChange={this.changeState} />
                </div>
              </div>
              <div class="form-group row">
                <label for="inputorg" className="col-sm-2 col-form-label">Organization</label>
                <div class="col-sm-10">
                  <input type="text" className="form-control" id="inputorg" placeholder="Organization" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.org} onChange={this.changeOrg} />
                </div>
              </div>
              <div class="form-group row">
                <label for="inputagency" class="col-sm-2 col-form-label">Agency</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" id="inputagency" placeholder="Agency" pattern="[a-zA-Z 0-9]+" minlength="4" maxlength="1000" required value={this.state.agency} onChange={this.changeAgency} />
                </div>
              </div> */}


              <div class="form-group row">
                <label for="inputpurpose" class="col-sm-3 col-form-label">Purpose
                <span style={{ color: "red" }}> &nbsp;
                    *(<i>Use Ctrl + left click or mouse dragging for multiple selections</i>)
                  </span></label>
                <div class="col-sm-8">
                  {this.props.product === 'Daily Snow Cover Area' ?
                    <select
                      multiple="true"
                      className="custom-select"
                      name="hd"
                      id="hd" onChange={this.changePurpose_multiple} required>
                      <option value='Snow cover database'>Snow cover database</option>
                      <option value='Snowmelt runoff'>Snowmelt runoff</option>
                      <option value='Climate change impact assessment '>Climate change impact assessment </option>
                      <option value='Hydrological modelling'>Hydrological modelling</option>
                      <option value='Snowmelt runoff modelling '>Snowmelt runoff modelling </option>

                      <option value="1">Others (please specify)</option>
                    </select>:null}

                    { this.props.product === 'Snow Cover Fraction' ?
                      <select
                        multiple="true"
                        className="custom-select"
                        name="hd"
                        id="hd"  onChange={this.changePurpose_multiple} required>


                        <option value='Snow cover fraction database '>Snow cover fraction database</option>
                        <option value='Climate change impact assessment'>Climate change impact assessment</option>
                        <option value='1'>Others (please specify)</option>
                      </select> :null}
                      { this.props.product === 'Spatial snowmelt rate forecast (3-days)' ?
                        <select
                          multiple="true"
                          className="custom-select"
                          name="hd"
                          id="hd"  onChange={this.changePurpose_multiple} required>




                          <option value='Snowmelt  runoff '>Snowmelt  runoff</option>
                          <option value='snowmelt rate forecast'>snowmelt rate forecast</option>
                          <option value='Water availability assessment '>Water availability assessment</option>
                          <option value='Climate change impact assessment'>Climate change impact assessment</option>
                          <option value='1'>Others (please specify)</option>
                        </select> : null}
                        {this.props.product==='Estimated spatial snowmelt rate'? <select 
                          multiple="true"
                          className="custom-select"
                          name="hd"
                          id="hd" onChange={this.changePurpose_multiple} required>
                          <option value='Snowmelt runoff'>Snowmelt runoff</option>
                          <option value='Water availability assessment'>Water availability assessment</option>
                          <option value='	Climate change studies '>	Climate change studies </option>
                          <option value='Hydrological modelling'>Hydrological modelling</option>
                          <option value='Snowmelt runoff modelling '>Snowmelt runoff modelling </option>

                          <option value="1">Others (please specify)</option>
                        </select>:null}

                  
                  <br /><br />
                  {
                    this.state.enableothers ? <input type="text" onChange={this.changePurpose} value={this.state.purpose} required /> : null
                  }
                  {/* <textarea className="form-control" id="inputpurpose" rows="5" value={this.state.purpose}
                    pattern="[a-zA-Z 0-9]+" minlength="25" maxlength="1000" onChange={this.changePurpose} required ></textarea> */}
                </div>

              </div>
              <div class="form-group row col-sm-12 justify-content-center">
                <div className="custom-control custom-checkbox pl-3">
                  <input
                    className="custom-control-input"
                    type="checkbox"
                    value={this.state.check}
                    disabled={this.state.disabled}
                    id="invalidCheck"
                    required
                    onChange={this.handleCheck}
                  />
                  <label className="custom-control-label" htmlFor="invalidCheck">
                    I hereby agree to cite the usage of this product in the reports/publications appropriately.
    
              </label>

                </div>
              </div>
              <div class="form-group row justify-content-center">
                <div class="col-sm-12">
                  <p>Citation:</p>
                  <p style={{ textAlign: "justify" }}>NRSC, 2021, {this.props.product}, Geospatial hydro products developed by National Remote Sensing Centre under National Hydrology Project,&nbsp;
<a href={`${domain.bhuvannhpurl}`}>{domain.bhuvannhpurl}</a>, Last accessed:&nbsp;{moment(new Date()).format("DD-MMM-YYYY")}</p>
                </div>
              </div>
              <div class="form-group row d-flex justify-content-center">

                <button type="submit" class="btn btn-primary text-capitalize" size="sm">Download</button>


                {/* <button type="submit" class="btn btn-primary text-capitalize" size="sm" onClick={this.props.toggle}>Close</button> */}
                {
                  this.state.loading ?
                    <div className="sweet-loading">
                      <FadeLoader
                        sizeUnit={"px"}
                        color={"#123abc"}
                        loading={this.state.loading}
                      />
                    </div> : null
                }


              </div>




              {/* <MDBInput label="Organization" background size="lg" required onChange={this.handleOrganization}/>
Purpose

<input type="submit"/> */}
            </form>


            {/* {this.state.enableDownload && (this.props.product === 'Daily Snow Cover Area' || this.props.product==='Spatial snowmelt rate forecast (3-days)') ?
            <button type="submit" class="btn btn-primary text-capitalize"  onClick={this.handleDownloadLink} size="sm">
          <a onClick={this.handleDownloadLink}>Download</a></button>
             :
              this.state.enableDownload ?
              <button type="submit" class="btn btn-primary text-capitalize"  onClick={this.handleDownload_one} size="sm">
               <a onClick={this.handleDownload_one}>Download</a></button> :
                null} */}
          </MDBModalBody>

        </MDBModal>
      </MDBContainer>
    );
  }
}

export default DownloadModal;
